import styled from "styled-components";
import Link from "next/link";
import { colors } from "../../../../styles/variables";

export const StyledCart = styled.div`
  margin-left: 20px;
  height: inherit;
  cursor: pointer;
`;

export const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
`;

export const StyledNumOfItems = styled.span`
  color: ${({ theme }) => theme.header?.shop?.navLinkColor || colors.white};
  margin-left: 5px;
  font-size: 14px;
`;
